import { PostgrestSingleResponse } from '@supabase/supabase-js';
import supabaseRequest from '../requesters/supabase.request';
const productService = {
  getProducts: async (query: any): Promise<PostgrestSingleResponse<any[]>> =>
    await supabaseRequest
      .from('products')
      .select()
      .filter('deleted_at', 'is', null),
  getUnitOptions: async (query: any): Promise<PostgrestSingleResponse<any[]>> =>
    await supabaseRequest
      .from('units')
      .select()
      .filter('deleted_at', 'is', null)
};
export default productService;
